import React from 'react';
import { Navigate } from 'react-router-dom'; 
import { getLocalStorage } from '../helpers/localstorage';

const withRoleProtection = (WrappedComponent, allowedRoles) => {
  return (props) => {
    const user = getLocalStorage("auth")?.user;
    const userRole = user?.role;

    if (!user) {
      return <Navigate to="/login" />;
    }

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" />;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withRoleProtection;
